export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <span className="inline-flex items-center gap-2 text-accent-600 text-sm font-medium mb-3">
            <i className="ri-send-plane-line"></i>
            投稿爆料
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            你有大瓜？快来爆料
          </h2>
          <p className="text-foreground-600 mb-10 leading-relaxed">
            手握独家明星八卦或网红内幕？爆瓜网欢迎每一位知情人士投稿。我们承诺严格保护爆料人隐私，所有投稿将经过专业编辑团队核实后发布，确保每一条爆料的真实性和独家性。
          </p>

          <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/70">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
              <div className="text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-3">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h3 className="font-heading font-bold text-foreground-900 text-sm mb-1">邮箱投稿</h3>
                <p className="text-xs text-foreground-500">tips@baogua.com</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-3">
                  <i className="ri-wechat-line text-xl"></i>
                </div>
                <h3 className="font-heading font-bold text-foreground-900 text-sm mb-1">微信爆料</h3>
                <p className="text-xs text-foreground-500">搜索「爆瓜网」公众号</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 mb-3">
                  <i className="ri-shield-check-line text-xl"></i>
                </div>
                <h3 className="font-heading font-bold text-foreground-900 text-sm mb-1">隐私保护</h3>
                <p className="text-xs text-foreground-500">严格匿名 · 绝不泄露</p>
              </div>
            </div>
            <a
              href="#"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3 rounded-lg font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-edit-line"></i>
              立即投稿爆料
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}